import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-brand_blue text-white border-t-4 border-black mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-chewy text-3xl mb-4">
              <span className="text-white">UNCLE</span>{' '}
              <span className="text-brand_red">DAVE'S</span>{' '}
              <span className="text-brand_yellow">LEMONADE</span>
            </h3>
            <p className="font-nunito text-sm">
              THE BEST LEMONADE EVER MADE
            </p>
          </div>

          <div>
            <h4 className="font-chewy text-xl mb-4">Shop</h4>
            <ul className="space-y-2 font-nunito">
              <li>
                <Link to="/products" className="hover:text-brand_yellow transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/products?category=lemonade" className="hover:text-brand_yellow transition-colors">
                  Lemonades
                </Link>
              </li>
              <li>
                <Link to="/products?category=merchandise" className="hover:text-brand_yellow transition-colors">
                  Merchandise
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-chewy text-xl mb-4">About</h4>
            <ul className="space-y-2 font-nunito">
              <li>
                <Link to="/about" className="hover:text-brand_yellow transition-colors">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/popup-program" className="hover:text-brand_yellow transition-colors">
                  Pop-Up Program
                </Link>
              </li>
              <li>
                <a href="mailto:info@uncledaves.com" className="hover:text-brand_yellow transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-chewy text-xl mb-4">Customer Service</h4>
            <ul className="space-y-2 font-nunito">
              <li>
                <Link to="/track-order" className="hover:text-brand_yellow transition-colors">
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/account" className="hover:text-brand_yellow transition-colors">
                  My Account
                </Link>
              </li>
              <li>
                <Link to="/admin" className="hover:text-brand_yellow transition-colors">
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-chewy text-xl mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a
                href="#"
                className="bg-white text-brand_blue p-2 rounded-full border-2 border-black shadow-hard hover:shadow-hard-hover hover:-translate-y-1 transition-all"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" strokeWidth={3} />
              </a>
              <a
                href="#"
                className="bg-white text-brand_blue p-2 rounded-full border-2 border-black shadow-hard hover:shadow-hard-hover hover:-translate-y-1 transition-all"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" strokeWidth={3} />
              </a>
              <a
                href="#"
                className="bg-white text-brand_blue p-2 rounded-full border-2 border-black shadow-hard hover:shadow-hard-hover hover:-translate-y-1 transition-all"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" strokeWidth={3} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-white/30 mt-8 pt-8 text-center font-nunito text-sm">
          <p>&copy; 2024 Uncle Dave's All Natural Lemonade. All rights reserved.</p>
          <p className="mt-2">Made with <span className="text-brand_red">❤</span> A WHOLE LOT OF LOVE</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;